import styled from "styled-components";

const H2 = styled.h2`
  width: 100%;
  font-size: 36px;
  padding: 1rem;
  margin: 0;
  padding-top: 50px;
  color: #cc9507;
`;

export default H2;
